import apiRequest from "./ApiService";

export const getRequest = async (endpoint,responseType) => {
  try {
    const data = await apiRequest('GET', endpoint, null, "application/json", { responseType: responseType });
    return data;
  } catch (error) {
    throw error.response || error;
  }
};

export const postRequest = async (endpoint, data, contentType="application/json") => {
  try {
    const response = await apiRequest('POST', endpoint, data, contentType);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const patchRequest = async (endpoint, data) => {
  try {
    const response = await apiRequest('PATCH', endpoint, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteRequest = async (endpoint) => {
  try {
    const response = await apiRequest('DELETE', endpoint);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const putRequest = async (endpoint, data) => {
  try {
    const response = await apiRequest('PUT', endpoint, data);
    return response;
  } catch (error) {
    throw error.response || error;
  }
}